module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/running/running.component.scss
// module id = ./src/app/running/running.component.scss
// module chunks = main